import { PROTECTED_ROUTES, registrarApplicantPath } from "@/navigation/routes";

export interface AdmissionsOrigin {
  origin: "admissions";
  applicantId: string;
  studentId: string;
}

export function admissionsOriginFromSearch(search: URLSearchParams): AdmissionsOrigin | null {
  const applicantId = search.get("applicant");
  const studentId = search.get("student");
  return search.get("origin") === "admissions" && applicantId?.trim() && studentId?.trim()
    ? { origin: "admissions", applicantId, studentId }
    : null;
}

export function applicantFileHref(origin: AdmissionsOrigin): string {
  return registrarApplicantPath(origin.applicantId);
}

export function admissionCourseSetupHref(studentId: string, applicantId: string | null): string {
  const search = new URLSearchParams({ student: studentId });
  if (applicantId) {
    search.set("origin", "admissions");
    search.set("applicant", applicantId);
  }
  return `${PROTECTED_ROUTES.admin.courses}?${search}`;
}
